import { Component, Input } from '@angular/core';
import { maintenanceData } from '../maintenance.interface';

@Component({
  selector: 'app-general-error',
  templateUrl: './general-error.component.html',
  styleUrls: ['./general-error.component.scss'],
  standalone: false,
})
export class GeneralErrorComponent {
  @Input() data: maintenanceData;
}
